import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from '@drone-js/core';
import { selectCmsFromBootstrap } from 'store/slice/bootstrap';
import { OverlayType, closeOverlay, selectGeoLocationDeniedOverlayVisible, selectNoActivitiesNearbyOverlayVisible } from 'store/slice/overlay';
import { trackElementEvent } from 'core/messaging/analytics/analytics';
import { ActivitiesGeoLocationDenyModalCloseButtonClickEventActivitiesFieldsV1 } from '@agoda/analytics-messages-definition-activities/events.split';
import { ActivitiesGeoLocationDenyModalCloseButtonClickEventActivitiesManifestV1 } from '@agoda/analytics-messages-definition-activities/manifest/events';

interface ModalContent {
    overlayType: OverlayType | null;
    title: string;
    description: string;
    dataElementName: string;
}

const LocationDeniedInfoModal: React.FC = React.memo(() => {
    const cms = useSelector(selectCmsFromBootstrap);
    const dispatch = useDispatch();
    const isGeoLocationDeniedVisible = useSelector(selectGeoLocationDeniedOverlayVisible);
    const isNoActivitiesNearbyVisible = useSelector(selectNoActivitiesNearbyOverlayVisible);
    const isModalVisible = isGeoLocationDeniedVisible || isNoActivitiesNearbyVisible;

    const getModalContent = () => {
        if (!isModalVisible) return { overlayType: null, title: '', description: '', dataElementName: '' };
        if (isNoActivitiesNearbyVisible) {
            return {
                overlayType: OverlayType.NoActivitiesNearby,
                title: cms[321649],
                description: cms[321515],
                dataElementName: 'activities-geo-location-not-found-modal',
            };
        }
        return {
            overlayType: OverlayType.GeoLocationDenied,
            title: cms[320882],
            description: cms[174896],
            dataElementName: 'activities-geo-location-deny-modal',
        };
    };

    const { overlayType, title, dataElementName, description }: ModalContent = getModalContent();

    const closeModal = () => {
        if (overlayType) {
            trackElementEvent<ActivitiesGeoLocationDenyModalCloseButtonClickEventActivitiesFieldsV1>(
                ActivitiesGeoLocationDenyModalCloseButtonClickEventActivitiesManifestV1.ids,
                {},
            );
            dispatch(closeOverlay(overlayType));
        }
    };

    return (
        <Modal
            visible={isModalVisible}
            title={title}
            data-element-name={dataElementName}
            onClose={closeModal}
            size="m"
            actions={[
                {
                    actionType: 'button',
                    hierarchy: 'primary',
                    label: cms[126815],
                    variant: 'label',
                    onClick: closeModal,
                },
            ]}
            description={description}
        />
    );
});

LocationDeniedInfoModal.displayName = 'LocationDeniedInfoModal';
export default LocationDeniedInfoModal;
